//
// wrapper around axios to include Rails CSRF token
//
import Axios from 'axios'
import { extendAxios } from '@springbig/sb-components';

const token = document.querySelector('[name="csrf-token"]') || {content: 'no-csrf-token'}
const axiosConfig = Axios.create({
  headers: {
    common: {
      'X-CSRF-Token': token.content
    }
  }
})

const extendedAxios = extendAxios(axiosConfig);

export default extendedAxios
export const axios = extendedAxios
